export const HIDE_UNSELECTED_ROWS_LABEL = 'Hide Unselected Rows';
export const HIDE_UNSELECTED_ROWS_TOOLTIP = 'Show only the selected records on every tab.';

export const CLEAR_ALL_BUTTON_LABEL = 'Clear Searches & Selected Rows';
export const CLEAR_SEARCH_RESULTS_AND_SELECTION_BUTTON_TOOLTIP =
  ' Clear search terms and selected rows across trafficking tables. Filters will remain unchanged';
